import audioScript from '../../src/audio.mp3';
import React from 'react';

const AudioPlayer = props => {
  const audioRef = React.useRef(null);
 
  const play = () => audioRef.current.play();
  const pause = () => audioRef.current.pause();
  const setVolume = value => audioRef.current.volume = value;
 
  const divStyle = {
    color: '#fff'
  };

  return (
    <div style={{ display: 'flex', flexDirectoin: 'row', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center', height: '100px' }}>
      <div style={{ display: 'flex',  justifyContent: 'center' }}>
      <audio ref={audioRef} src={props.src} controls></audio>
    </div>
    <small style={divStyle}>Если лень читать, можно послушать, никто не узнает 😉</small>
    </div>
  );
};

const About = () => {
  return (
    <div className="homepageBlock">
      <h3 className="about-header">Вкратце обо мне.</h3>
      <p className="about-paragraph">Привет еще раз! Я - Илья. Я - Фронтенд разработчик, диджитал и моушн дизайнер, немножко умею в реакт (данный сайт на нём написан), немножко в питон, немного тайпскрипт, также есть опыт разработки под Arduino, PHP, Blender 3D, After Effects, и другие языки и программы. Очень люблю придумывать штуки, которых ни у кого нет.</p>
      <p className="about-paragraph">Путь свой я начал в далёком 2008 году, будучи играя в игры, хотел сделать сайт клана. И так я начал изучение HTML+CSS, это и стало моей первой профессией. Верстальщиком я был на то время отменным (Когда код был сильно проще 😂). В 2016 году стал победителем конкурса HTML вёрстки на время на питерском форуме. В то же время работа подтолкнула меня к знакомству с Javascript. Он помог мне интегрировать в мои работы больше интерактивности, возможность управлять более детально элементами в DOM.</p>
      <p className="about-paragraph">В роли баннермейкера и в частности работы со всякими фреймворками и программами, связанными с анимацией, я открыл для себя максимум в создании красивых и эффектных рекламных продуктов в интернете. В 2018-2019 научился разрабатывать игровых приложений для веб. В 2021 году познакомился с тайпскрипт, реакт, вью (На начальном уровне). Сейчас пробую себя в новых проектах, хочется создавать всегда новое. И этим новым для меня стала 3Д печать и моделирование.</p>
      <AudioPlayer src={audioScript} />
      </div>
  );
};

export default About;